import {createSlice, PayloadAction, AnyAction} from '@reduxjs/toolkit';
import {ICategoriesState} from 'modules/categories/types';
import {HYDRATE} from 'next-redux-wrapper';
import {IRootReducer} from 'core/redux/reducers';

export const categoryModuleName = 'category';

const initialState: ICategoriesState = {
    categoriesList: [],
    categoriesTreeList: [],
    productPreviewList: {},
};

export const categoriesSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(HYDRATE, (state, action: AnyAction) => {
            const payload = action.payload as IRootReducer | undefined;
            if (!payload) {
                return state;
            }

            return payload[categoryModuleName];
        });
    },
    initialState,
    name: categoryModuleName,
    reducers: {
        actionSetPreviewProductList(state, {payload}: PayloadAction<ICategoriesState['productPreviewList']>) {
            state.productPreviewList = payload;
        },
    },
});

export const {
    actions: {actionSetPreviewProductList},
} = categoriesSlice;

export const {reducer: categoriesReducer} = categoriesSlice;
